export const environment = {
  production: false,
  apiUrl: 'https://api.staging.sapptradingpro.com/api/v1',
  apiTestUrl: 'http://57.128.245.130:8082/api/v1',
};
